import { makeStyles } from '@material-ui/core';

import { colors } from '../../assets/theme/palette';

/**
 * Mirrors the data-table footer styles in `useOasisDataTable` so a standalone
 * bar is indistinguishable from the one inside a table. The caption ordering
 * trick is what puts the bold "Rows per page" label before its select and
 * right-aligns the "x–y of z" range. Once the table adopts this component,
 * its inline copy of these styles goes away.
 */
export const useStyles = makeStyles({
  root: {
    border: 'none',
    padding: 0,
  },
  toolbar: {
    flex: 1,
    padding: '0 16px',
  },
  spacer: {
    flex: 'initial',
  },
  caption: {
    '&:nth-of-type(2)': {
      order: -1,
      marginRight: 20,
      color: colors.grey140,
      fontWeight: 'bold',
    },
    '&:nth-of-type(1)': {
      flex: 1,
      textAlign: 'right',
      color: colors.grey140,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
  },
});
